/**
 * The loading splash — «WELCOME PAGE».
 *
 * The first thing anyone sees, and it did not exist: the app went straight from
 * a bare warning screen to the library. The board is one full-bleed painting
 * with «Загрузка...» over it, and the art carries the NARRA wordmark — which is
 * how we learned the app is called NARRA and «Высокая кухня» is a book inside it.
 *
 * Shown while the pack and catalogue are still in flight. It holds for a beat
 * even on a fast connection, because a splash that flashes for 40ms reads as a
 * glitch rather than as a brand.
 */
import { useEffect, useState } from 'react';

/** Long enough to register as deliberate, short enough not to be a toll gate. */
const MIN_MS = 900;

export function Welcome({ onDone }: { onDone: () => void }) {
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    const id = window.setTimeout(() => {
      setLeaving(true);
      // Let the fade finish before the next screen mounts under it.
      window.setTimeout(onDone, 260);
    }, MIN_MS);
    return () => window.clearTimeout(id);
  }, [onDone]);

  return (
    <div className={leaving ? 'welcome is-leaving' : 'welcome'} role="status" aria-live="polite">
      <p className="welcome-loading">Загрузка...</p>
    </div>
  );
}
